import './index.scss'
import { createDict } from '@/util/dicts'
import { Select as iSelect } from 'iview'

const isFunction = v => Object.prototype.toString.call(v) == '[object Function]' 
const isPromise = v => Object.prototype.toString.call(v) == '[object Promise]' 
const isArray = v => Array.isArray(v)
const inner = {
  org(data){
    return data ? data.map( i => ({value:i.id , label:i.name})) : []
    //return data.list ? data.list.map( i => ({value:i.id , label:i.companyName})) : []
  },
  company(data){
    return data ? data.map( i => ({value:i.id , label:i.companyName})) : []
    //return data.list ? data.list.map( i => ({value:i.id , label:i.companyName})) : []
  },
  role(data){
    return data ? data.map( i => ({value:i.id , label:i.name})) : []
  },
  post(data){
    return data ? data.map( i => ({value:i.id , label:i.name})) : []
  },
  carcate(data){
    return data ? data.map( i => ({value:i.id , label:i.name})) : []
  },
  level(data){
    return data ? data.map( i => ({value:i.id , label:i.name})) : []
  },
  brand(data){
    return data ? data.map( i => ({value:i.id , label:i.brandShortName})) : []
  },
  "brand:name"(data){
    return data ? data.map( i => ({value:i.brandShortName , label:i.brandShortName})) : []
  }
}

const dataCache = {}

const getValues = () => {

}

export default {
  name: 'Select',
  data() {
    return {
      display: false,
      values: [],
      renderValues:[],
      insVal: null,
      dataLoading: true
    }
  },
  props: {
    autoFill:{
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullProps: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'select'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    value: {
      default: null
    },
    valueType:{
      type: String,
      default: 'number'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dict: {
      default: ''
    },
    filterable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    cache:{
      type:Boolean,
      default:false
    },
    //禁止触发 on-form-change
    silent: {
      type: Boolean,
      default: false
    },
    remote:{
      type:Object,
      default:null
    },
    data: {
      default: function() {
        return []
      }
    },
    group:false,
    before:null,
    after:null,
    cascaderLastValue:{
      default:false
    },
    changeOnSelect:{
      type: Boolean,
      default: false
    },
    renderFormat:{
      type:Function,
      default:label => label.join(' / ')
    },
    disabledItems:{
      type:Array,
      default(){
        return []
      }
    },
    extra:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  
  created() {
    if(this.remote){
      this.getRequestData(this.remote.api ,this.remote.params, this.remote.parser)
    }

    this.$watch('data' , function(nv){
      if (nv && nv.length) {
        this.dataLoading = false
        this.setValues(nv)

      }
    },{immediate: true})

    this.$watch('value' , function(nv){
      if( this.values && this.values.length ){
        this.update()
      }
    },{immediate: true})

    this.$watch('dict' , function(val){
      if(!val) return;

      if(inner[val]){
        this.getRequestData('common_'+val ,this.extra, inner[val])
      }else{
        const process = typeof val == 'string' ? createDict(val , this.valueType) : val
        console.log('>>>',process)

        this.processDict(process)
      }

    },{immediate: true})

    this.$watch('values' , function(){
      this.update()
    },{deep:true})
  },
  methods: {
    setValues(v){
      if( this.group ){
        this.renderValues = v
        this.values = [].concat(
          this.before || [] , 
          v.reduce((t,c) => t.concat(c.children || []),[])
         , this.after || []
        )
      }else{
        this.renderValues = this.values = [].concat(this.before || [] , v , this.after || [])
      }
      this.update()
    },
    processDict(process){
      if(Array.isArray(process)){
        this.dataLoading = false
        this.setValues(process)
      }
      else if(isFunction(process)){
        let result = process()
        this.dataLoading = true
        if(isPromise(result)){
          result.then(resp => {
            this.dataLoading = false
            this.setValues(resp)
          })
        }else if(Array.isArray(result)){
          this.dataLoading = false
          this.setValues(result)
        }
      }
      else if(isPromise(process)){
        this.dataLoading = true
        process.then(resp => {
          this.dataLoading = false
          this.setValues(resp)
        })
      }
    },
    getRequestData(url , params = {}, parser){
      let { dict } = this
      if(this.cache && dataCache[dict]){
        this.setValues(dataCache[dict])
        this.dataLoading = false
      }else{
        this.dataLoading = true
        this.$request[url](params).then(resp => {
          this.dataLoading = false
          let data = resp.data
          if(parser){
            data = parser(resp.data)
          }
          dataCache[dict] = data
          this.setValues(data)
        })
      }
    },
    update() {
      this.$emit('ready' , this.values)
      let insVal
      if(this.autoFill && this.values.length && (this.value === null || this.value == undefined )){
        //this.insVal = this.values[0].value
        //insVal = this.values[0].value
        this.handleChange(this.values[0].value)
        return
      }else{
        insVal = (this.value === null || this.value == undefined ) ? undefined : this.formatValue(this.value)
      }

      if( this.type == 'cascader' && this.cascaderLastValue ){
        if( insVal ){
          let hash = flatten(this.values)
          let r = [] , next = insVal
          while(next){
            let d = hash[next]
            if(d){
              r.unshift( d.value )
              if(d.parentId){
                next = d.parentId
              }else{
                break
              }
            }else{
              break
            }
          }

          insVal = r
        }else{
          insVal = []
        }
      }

      this.insVal = insVal

    },
    formatValue(v){
      if(this.valueType == 'number'){
        return Array.isArray(v) ? v.map( Number) : Number(v)
      }else{
        return Array.isArray(v) ? v.map( String) : String(v)
      }
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params));
      }
    },

    handleChange(val) {
      if (this.insVal !== val) {
        this.insVal = val

        let publicValue = val
        let vModelValue = val

        if (this.multiple) {
          if (this.fullProps) {
            vModelValue = val.map(i => {
              return this.values.find(j => (j.value == i))
            })
          }
        } else {
          if (this.fullProps) {
            vModelValue = this.values.find(i => (i.value == val))
          }
        }

        if( this.type == 'cascader' && this.cascaderLastValue ){
          publicValue = publicValue[publicValue.length-1]
        }

        this.$emit('input', publicValue) // v-model
        this.$emit('change', publicValue)
        this.$emit('change-data', this.values.find(i => (i.value == val)))
        this.$emit('on-change', vModelValue)
        if (!this.silent) {
          this.dispatch('FormItem', 'on-form-change', [].concat(publicValue))
        }
      }
    },
    handleClear() {
      this.$emit('on-clear')
      this.handleChange(null)
    },
    renderRadio(){
      const {disabled} = this
      return <RadioGroup ref="ins" disabled={this.disabled} type={this.type == 'button' ? 'button' : null} value={this.insVal} on-on-change={this.handleChange}>
        {
          this.renderValues.map(i => (
            <Radio disabled={disabled} label={i.value}>
              {
                i.icon ? <Icon custom={'i-icon '+i.icon} /> : null
              }
              {i.label}
            </Radio>
          ))
        }
      </RadioGroup>
    },
    renderSelectOption(item){
      const itemNode = this.$scopedSlots.option ? this.$scopedSlots.option(item) : [
        <span>{ item.label }</span>,
        item.placeholder ? <span style="float:right;color:#ccc">{item.placeholder}</span> : null
      ]
      let disabled = this.disabledItems.includes(item.value) || !!item.disabled
      return <Option value={item.value} label={item.label} disabled={disabled}>
        {itemNode}
      </Option>
    },
    renderSelect(){
      // console.log('insVal',this.insVal)
      let loading = this.dataLoading || this.loading
      let placeholder = loading ? '加载中' : this.placeholder
      return <i-select style="position:relative;" ref="ins" class={{'select-loading':loading}} transfer={this.transfer} multiple={this.multiple} disabled={this.disabled} loading={loading} value={this.insVal} placeholder={placeholder} on-on-change={this.handleChange} filterable={this.filterable} clearable={this.clearable} on-on-clear={this.handleClear}>
        {
          this.renderValues.map(i => {
            if( i.children ){
              return <OptionGroup label={i.label}>
                {
                  i.children.map(this.renderSelectOption)
                }
              </OptionGroup>
            }else{
              return this.renderSelectOption(i)
            }
          })
        }
      </i-select>
    },
    renderCascader(){
      let loading = this.dataLoading || this.loading
      let placeholder = loading ? '加载中' : this.placeholder

      return <Cascader style="position: relative;" placeholder={placeholder} transfer={this.transfer} class={{'select-loading':loading}}  transfer={this.transfer} clearable={this.clearable} data={this.renderValues} on-on-change={this.handleChange} value={this.insVal || []} render-format={this.renderFormat} change-on-select={this.changeOnSelect} />
    }
  },
  render(){
    if( this.type == 'radio' || this.type == 'button'){
      return this.renderRadio()
    }else if(this.type == 'cascader'){
      return this.renderCascader()
    }else{
      return this.renderSelect()
    }
  }
}
